module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_FI-d7240a891fea7a5f283174f35ee012f9.svg";